<template>
  <div>
    <EditMessageModal :messageData="messageData" :association_id="association_id" @open-main-modal-again="openMainModal"/>
    <button class="d-none" data-toggle="modal" data-target="#messageBoardModal" ref="openModalMessageView"></button>
    <div class="modal fade" id="messageBoardModal" tabindex="-1" role="dialog" aria-labelledby="messageBoardModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="messageBoardModalLabel">Message Details</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeModalMessageDetail"
              @click="updateCounter"
            >
              <img src="../assets/Svg/close.svg" />
            </button>
          </div>

          <div class="modal-body">
            <EditMessage :messageId="messageId" :showLoader1="showLoader1" :showReplyLoader="showReplyLoader"
              :showLoader="showLoader" :messageData="messageData" :replies="replies" :currentIsAdmin="currentIsAdmin"
              :currentIsUmpire="currentIsUmpire" :association_id="association_id" :page="page"
              :msgLastPage="msgLastPage" @toggleReplyLoader="toggleReplyLoader"
              @page-increment="handleRepliesIncrement" @close-modal="closeModal"/>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import EditMessage from "../components/Association/EditMessage.vue";
import EditMessageModal from "../components/Association/Modals/EditMessageModal.vue";

export default {
  name: "MessagesBoard",
  components: { EditMessage, EditMessageModal },
  data() {
    return {
      messageId: null,
      messageData: {},
      replies: [],
      association_id: 0,
      currentIsAdmin: "0",
      currentIsUmpire: "0",
      showLoader: 1,
      showLoader1: 1,
      page: 1,
      msgLastPage: 1,
      showReplyLoader: 1,
    };
  },
  props: {
    events: {
      type: Array,
    },
  },
  // created() {
  //   this.fetchMessageId();
  // },
  methods: {
    closeModal() {
      this.$refs.closeModalMessageDetail?.click(); // simulate the close button click
    },
    updateCounter() {
      this.$root.$emit("fetchMesages");
    },
    openMainModal() {

      var elem = this.$refs.openModalMessageView;
      if (elem) {
        elem.click();
        this.fetchMessageId();
        this.$nextTick(() => {
          this.$root.$emit("resetMessageValidation");
        });
      }
    },
    handleRepliesIncrement() {
      this.page++; // Update the page prop
      this.fetchReplies();
    },
    async fetchMessageId() {
      try {
        this.messageId = String(this.messageContent?.guid);
        await this.fetchMessageData();
      } catch (error) {
        console.error("Failed to fetch message ID:", error);
      }
    },
    async fetchMessageData() {
      this.showLoader = 1;
      try {
        const url = `${process.env.VUE_APP_API_URL}associationEvent/viewMessage`;

        const response = await axios.post(url, {
          message_id: this.messageId,
        });

        if (response.data.statusCode === 200) {
          this.messageData = response.data.data;
          this.association_id = response.data.data?.user_association_role?.association_id;
          this.currentIsAdmin = (response.data.data.user_association_role) ? (response.data.data.user_association_role.role_id == 1) ? '1' : '0' : '0';
          this.currentIsUmpire = (response.data.data.user_association_role) ? (response.data.data.user_association_role.role_id == 2) ? '1' : '0' : '0';

          this.showLoader = 0;
          this.fetchReplies();
        }
        else if (response.data.statusCode === 404) {
          this.$alert(response.data.message, 'Error');
          this.$router.push({ name: "Teams" });
          this.showLoader = 0; // Hide loader
        } else {
          console.error(
            "Failed to fetch message data:",
            response.data.message || "Unknown error occurred"
          );
          this.showLoader = 0;
        }
      } catch (error) {
        this.showLoader = 0;
        console.error("Failed to fetch message data:", error);
      }
    },
    async fetchReplies() {
      this.showLoader1 = 1;
      this.showReplyLoader = 1;
      try {
        const url = `${process.env.VUE_APP_API_URL}associationEvent/getReplies`;
        const response = await axios.post(url, {
          parent_id: this.messageData.id,
          page: this.page, // Include the page parameter
        });

        if (response.data.statusCode === 200) {
          const newReplies = response.data.data.data;
          const lastPage = response.data.data.last_page;

          // Check if page > 1
          if (this.page > 1) {
            // Append new replies to existing ones
            this.replies = [...this.replies, ...newReplies];
          } else {
            // Clear the array and replace with new replies
            this.replies = newReplies;
          }

          // Update last page
          this.msgLastPage = lastPage;

          this.showLoader1 = 0;
          this.showReplyLoader = 0;
        } else {
          console.error(
            "Failed to fetch replies:",
            response.data.message || "Unknown error occurred"
          );
          this.showLoader1 = 0;
          this.showReplyLoader = 0;
        }
      } catch (error) {
        this.showLoader1 = 0;
        console.error("Failed to fetch replies:", error);
      }
    },
    toggleReplyLoader(showLoader) {
      this.showReplyLoader = showLoader;
    },

  },
  mounted() {
    this.$root.$on("editMessageChange", () => {
      this.fetchMessageData();
    });
    this.$root.$on("fetchRepliesEmit", () => {
      this.fetchReplies();
      // this.fetchMessageData();
    });
    this.$root.$on("replies-increment", () => {
      this.handleRepliesIncrement();
    });
    this.$root.$on("fetchReplyAfterDelation", () => {
      this.fetchReplies();
    });

    this.$root.$on("openMessageViewModal", (item) => {
      this.messageContent = item;
      var elem = this.$refs.openModalMessageView;
      if (elem) {
        elem.click();
        // this.$v.$reset();
        this.fetchMessageId();
      }

    });

    // this.fetchMessageData();

  },
};
</script>
